<template>
  <section class="dp-layout">
    <section class="dp-right op-page">
    <header class="op-page__head">
      <div>
        <div class="op-page__eyebrow">Callback delivery</div>
        <h3 class="op-page__title">回调推送日志</h3>
        <p class="op-page__desc">跟踪天波门禁事件入站和合作方回调投递，集中处理映射缺失、重试和最终失败。</p>
      </div>
      <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新回调</el-button>
    </header>

    <el-tabs v-model="tab" @tab-click="handleTab">
      <el-tab-pane label="入站事件" name="inbox" />
      <el-tab-pane label="待投递" name="pending" />
      <el-tab-pane label="投递成功" name="succeeded" />
      <el-tab-pane label="待重试" name="retry" />
      <el-tab-pane label="最终失败" name="dead" />
      <el-tab-pane label="无合作方映射" name="noPartner" />
    </el-tabs>

    <div class="toolbar-filter-bar">
    <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent>
      <div class="toolbar-filter-fields">
      <el-form-item label="学校编号">
        <el-input v-model="filters.schoolDepartmentId" clearable class="toolbar-field-w-lg" />
      </el-form-item>
      <el-form-item label="事件类型">
        <el-select v-model="filters.eventType" clearable class="toolbar-field-w-lg">
          <el-option label="通行记录" value="doorRecord" />
          <el-option label="设备在线状态" value="doorDeviceStatus" />
        </el-select>
      </el-form-item>
      <el-form-item label="事件编号">
        <el-input v-model="filters.eventId" clearable class="toolbar-field-w-md" />
      </el-form-item>
      <el-form-item label="设备序列号">
        <el-input v-model="filters.deviceSn" clearable class="toolbar-field-w-xl" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
      </el-form-item>
      </div>
    </el-form>
    </div>

    <div class="tbl-scroll-host">
    <el-table v-if="isInboxTab" :data="tableData" v-loading="loading" size="small" stripe empty-text="暂无记录"
      height="100%" class="custom-tbl" style="width: 100%">
      <el-table-column prop="CreateTime" label="时间" width="158" />
      <el-table-column label="事件类型" width="120">
        <template slot-scope="scope">{{ eventTypeText(scope.row.EventType) }}</template>
      </el-table-column>
      <el-table-column prop="SourceEventKey" label="源事件键" min-width="150" show-overflow-tooltip />
      <el-table-column label="学校" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.SchoolName || '—' }}</div>
          <div v-if="scope.row.SchoolId" class="op-sub">{{ scope.row.SchoolId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="处理状态" width="120">
        <template slot-scope="scope">
          <span :class="statusClass(scope.row.ProcessStatus)">{{ inboxStatusText(scope.row.ProcessStatus) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="PayloadSummary" label="内容摘要" min-width="160" show-overflow-tooltip />
      <el-table-column label="失败原因" min-width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :class="scope.row.ErrorMessage ? 'is-bad' : 'op-muted'">
            {{ failReasonText(scope.row.ErrorMessage, scope.row.ProcessStatus === 'Processed' ? '—' : tipForInbox(scope.row)) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openInboxDetail(scope.row)">看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-table v-else :data="tableData" v-loading="loading" size="small" stripe empty-text="暂无记录"
      height="100%" class="custom-tbl" style="width: 100%">
      <el-table-column prop="CreateTime" label="时间" width="158" />
      <el-table-column label="事件类型" width="120">
        <template slot-scope="scope">{{ eventTypeText(scope.row.EventType) }}</template>
      </el-table-column>
      <el-table-column prop="EventId" label="事件编号" min-width="150" show-overflow-tooltip />
      <el-table-column label="学校" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ scope.row.SchoolName || '—' }}</div>
          <div class="op-sub">{{ scope.row.SchoolId }}</div>
        </template>
      </el-table-column>
      <el-table-column label="推送状态" width="120">
        <template slot-scope="scope">
          <span :class="statusClass(scope.row.Status)">{{ outboxStatusText(scope.row.Status) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="AttemptCount" label="已试次数" width="80" align="right" />
      <el-table-column prop="TargetUrl" label="推到哪里" min-width="180" show-overflow-tooltip />
      <el-table-column label="失败原因" min-width="200" show-overflow-tooltip>
        <template slot-scope="scope">
          <span :class="scope.row.LastError ? 'is-bad' : 'op-muted'">
            {{ failReasonText(scope.row.LastError, scope.row.Status === 'Succeeded' ? '—' : tipForOutbox(scope.row)) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="openOutboxDetail(scope.row)">看详情</el-button>
          <el-button v-if="tab === 'retry' || tab === 'dead'" type="text" size="mini"
            @click="retry(scope.row)">再推一次</el-button>
        </template>
      </el-table-column>
    </el-table>
    </div>

    <el-col :span="24" class="toolbar">
      <el-pagination layout="total, prev, pager, next" :current-page.sync="page" :page-size="pageSize"
        :total="total" style="float: right" @current-change="load" />
    </el-col>

    <el-dialog :title="detailTitle" :visible.sync="detailVisible" width="640px" custom-class="op-detail-dialog">
      <el-descriptions v-if="detail" :column="1" size="small" border>
        <el-descriptions-item v-for="item in detailRows" :key="item.label" :label="item.label">
          <span :class="item.bad ? 'is-bad' : ''">{{ item.value }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer">
        <el-button type="primary" @click="detailVisible = false">知道了</el-button>
      </div>
    </el-dialog>
    </section>
  </section>
</template>

<script>
import {
  getPartnerCallbackInboxPage,
  getPartnerCallbackOutboxPage,
  retryPartnerCallbackOutbox
} from '@/api/modules/openPlatform';
import {
  eventTypeText,
  inboxStatusText,
  outboxStatusText,
  statusClass,
  failReasonText
} from '@/utils/openPlatformLabels';

export default {
  name: 'CallbackLog',
  data() {
    return {
      loading: false,
      tab: 'inbox',
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      filters: {
        schoolDepartmentId: '',
        eventType: '',
        eventId: '',
        deviceSn: ''
      },
      detailVisible: false,
      detailTitle: '详情',
      detail: null,
      detailRows: []
    };
  },
  computed: {
    isInboxTab() {
      return this.tab === 'inbox' || this.tab === 'noPartner';
    }
  },
  created() {
    this.load();
  },
  methods: {
    eventTypeText,
    inboxStatusText,
    outboxStatusText,
    statusClass,
    failReasonText,
    tipForInbox(row) {
      if (row.ProcessStatus === 'NoPartnerMapping') {
        return '这所学校还没开通合作方，或应用已停用/删除，事件收了但推不出去';
      }
      if (row.ProcessStatus === 'Failed') {
        return '处理入库时出错，请看详情或联系研发查日志';
      }
      return '暂无详细原因';
    },
    tipForOutbox(row) {
      if (row.Status === 'Dead') {
        return '推了多次还不行，已放弃。可点「再推一次」，或先检查合作方回调地址是否通';
      }
      if (row.Status === 'Pending' && (row.AttemptCount || 0) > 0) {
        return '上次推失败了，系统会自动再试。也可手动「再推一次」';
      }
      if (row.Status === 'Pending') {
        return '排队等待推送中';
      }
      return '暂无详细原因';
    },
    handleTab() {
      this.page = 1;
      this.$nextTick(() => this.load());
    },
    handleSearch() {
      this.page = 1;
      this.load();
    },
    load() {
      this.loading = true;
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        tab: this.tab,
        ...this.filters
      };
      Object.keys(params).forEach(k => {
        if (params[k] === '' || params[k] === null || params[k] === undefined) delete params[k];
      });
      const req = this.isInboxTab
        ? getPartnerCallbackInboxPage(params)
        : getPartnerCallbackOutboxPage(params);
      req.then(res => {
        this.loading = false;
        if (res.data && res.data.success) {
          const page = res.data.response || {};
          this.tableData = page.data || [];
          this.total = page.dataCount || 0;
        } else {
          this.$message.error((res.data && res.data.msg) || '加载失败');
        }
      }).catch(() => { this.loading = false; });
    },
    openInboxDetail(row) {
      this.detailTitle = '收到的门禁事件 · 详情';
      this.detail = row;
      this.detailRows = [
        { label: '时间', value: row.CreateTime || '—' },
        { label: '事件类型', value: eventTypeText(row.EventType) },
        { label: '源事件键', value: row.SourceEventKey || '—' },
        { label: '学校', value: row.SchoolName ? `${row.SchoolName}（${row.SchoolId || ''}）` : (row.SchoolId || '—') },
        { label: '处理状态', value: inboxStatusText(row.ProcessStatus) },
        { label: '内容摘要', value: row.PayloadSummary || '—' },
        {
          label: '失败原因',
          value: failReasonText(row.ErrorMessage, this.tipForInbox(row)),
          bad: !!(row.ErrorMessage || row.ProcessStatus === 'Failed' || row.ProcessStatus === 'NoPartnerMapping')
        },
        { label: '关联出站编号', value: row.OutboxId || '—' }
      ];
      this.detailVisible = true;
    },
    openOutboxDetail(row) {
      this.detailTitle = '推给合作方 · 详情';
      this.detail = row;
      this.detailRows = [
        { label: '时间', value: row.CreateTime || '—' },
        { label: '事件类型', value: eventTypeText(row.EventType) },
        { label: '事件编号', value: row.EventId || '—' },
        { label: '学校', value: row.SchoolName ? `${row.SchoolName}（${row.SchoolId || ''}）` : (row.SchoolId || '—') },
        { label: '推送状态', value: outboxStatusText(row.Status) },
        { label: '已试次数', value: String(row.AttemptCount == null ? '—' : row.AttemptCount) },
        { label: '下次再试时间', value: row.NextRetryTime || '—' },
        { label: '推到哪里', value: row.TargetUrl || '—' },
        {
          label: '失败原因',
          value: failReasonText(row.LastError, this.tipForOutbox(row)),
          bad: !!(row.LastError || row.Status === 'Dead' || ((row.AttemptCount || 0) > 0 && row.Status === 'Pending'))
        },
        { label: '成功时间', value: row.SucceededTime || '—' }
      ];
      this.detailVisible = true;
    },
    retry(row) {
      this.$confirm(`将用相同事件编号「${row.EventId}」再推一次，确认？`, '二次确认', { type: 'warning' })
        .then(() => retryPartnerCallbackOutbox(row.Id))
        .then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已安排再推');
            this.load();
          } else this.$message.error((res.data && res.data.msg) || '失败');
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
.op-sub { margin-top: 2px; font-size: 12px; color: #c0c4cc; }
.op-muted { color: #c0c4cc; }
.is-ok { color: #67c23a; }
.is-warn { color: #e6a23c; }
.is-bad { color: #f56c6c; }
</style>
